import React, { useState, useEffect, useRef } from 'react';
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../DynamicForm/DynamicForm';
import axiosInstance from '../../../../../services/api/API';
import { showCustomAlert } from '../../../../../customComponents/CustomSweetAlert';
import { showAlert } from '../../../../../customComponents/CustomSweetAlert/ShowAlert';
import { showErrorAlert } from '../../../../../customComponents/CustomSweetAlert/errorsweetalert';
import Loader from '../../../../../customComponents/CustomLoader';
import { set } from 'date-fns';
import validations from '../../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../../helpers/common';

const AddVariant = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subproductOptions, setSubproductOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [fuelOptions, setFuelOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [colorOptions, setColorOptions] = useState([]);
  const [seatingCapacityOptions, setSeatingCapacityOptions] = useState([]);
  const [noOfWheelsOptions, setNoOfWheelsOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);

  const [motorWarranty, setMotorWarranty] = useState([]);
  const [converterWarranty, setConverterWarranty] = useState([]);
  const [controllerWarranty, setControllerWarranty] = useState([]);

  const [hsncodeOptions, setHsnCodeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const [applysubsidy, setApplysubsidy] = useState(false);
  const userType = localStorage.getItem('UserType');
  const businessPartnerId = localStorage.getItem('business_partner_id');
  const [taxsetDropdown, setTaxSet] = useState([]);
  const [stateDdl, setStateDdl] = useState([]);
  const [batteryOptions, setBatteryOptions] = useState([]);
  const prevModelRef = useRef(formData.model);

  useEffect(() => {
    userTypedropdown();
    fetchTaxSetDropdown();
  }, []);

  useEffect(() => {
    stateDropdown();
  }, []);

  const stateDropdown = async () => {
    try {
      const response = await axiosInstance.get('/pincodestatecity/stateList', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));

      setStateDdl(data);
    } catch (error) {
      console.log(error);
    }
  };

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get('/bp-onboard/bplist', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));

      setUserTypedd(data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        '/tax/ddltax',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, 'VARIANTDATA');

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error('Error fetching department list:', error);
    }
  };

  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');
  // const businessPartnerId = 1; // Use the actual business_partner_id

  const VariantInputs = [
    {
      name: 'productName',
      label: 'Product',
      type: 'dropdown',
      options: productOptions,
      required: true,
      validation: {
        required: true,
      },
      gridClass: 'col-lg-4',
    },
    {
      name: 'model',
      label: 'Model',
      type: 'dropdown',
      options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'variantName',
      label: 'Battery',
      placeholder: 'Enter Variant Name',
      type: 'dropdown',
      options: batteryOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'vehiclecolor',
      label: 'Color',
      type: 'dropdown',
      options: colorOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },

    {
      name: 'state_id',
      label: 'State',
      type: 'dropdown',
      options: stateDdl,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'dealer_price',
      label: 'Dealer Price',
      placeholder: 'Enter Price',
      type: 'number',
      isDecimal: true,
      validation: validations.price({ required: true, minLength: 1 }),
      required: true,
      gridClass: 'col-lg-4',
      // type: "text",
      // validation: {
      //   required: true,
      //   minLength: 1,
      //   maxLength: 6,
      //   pattern: /^(?=.{1,6}$)(0|[1-9]\d*)(\.\d{1,2})?$/,
      //   message:
      //     "Dealer Price must be 1–6 digits long, can include 0, and allow up to 2 decimal places",
      // },
    },
    {
      name: 'exshowroomprice',
      label: 'Recommended Selling Price',
      placeholder: 'Recommended Selling Price',
      // type: "text",
      type: 'number',
      isDecimal: true,
      validation: validations.price({ required: true, minLength: 1 }),
      // validation: {
      //   required: true,
      //   minLength: 1,
      //   maxLength: 6,
      //   pattern: /^(?=.{1,6}$)(0|[1-9]\d*)(\.\d{1,2})?$/,
      //   message:
      //     "Recommended Selling Price must be 1–6 digits long, can include 0, and allow up to 2 decimal places",
      // },
      required: true,
      gridClass: 'col-lg-4',
    },
    ...(applysubsidy
      ? [
          {
            name: 'subsidyprice',
            label: 'subsidy price',
            placeholder: 'subsidy price',
            // type: "text",
            type: 'number',
            isDecimal: true,
            validation: validations.price({ required: true, minLength: 1 }),
            disabled: true,
            // validation: {
            //   required: true,
            // },
            required: true,
            gridClass: 'col-lg-4',
          },
        ]
      : []),

    {
      name: 'taxid',
      label: 'Tax',
      type: 'dropdown',
      options: taxsetDropdown,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'description',
      label: 'Variant Name',
      placeholder: 'Enter Variant Name',
      type: 'text',
      disabled: true,
      validation: validations.variant({ required: true }),
      // validation: {
      //   required: true,

      //   minLength: 5,
      //   maxLength: 80,

      //   // Enforces no spaces + length 5–100
      //   // pattern: /^[A-Za-z ]{5,80}$/,
      //   pattern: /^[A-Za-z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{5,80}$/,

      //   message:
      //     "Variant Name must be 5-80 characters long and can contain spaces",
      // },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'converter_warranty_id',
      label: 'Converter ',
      type: 'dropdown',
      options: converterWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'motor_warranty_id',
      label: 'Motor ',
      type: 'dropdown',
      options: motorWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'controller_warranty_id',
      label: 'Controller ',
      type: 'dropdown',
      options: controllerWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'charger_warranty_id',
      label: 'Charger Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'mcb_warranty_id',
      label: 'MCB Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'throttle_warranty_id',
      label: 'Throttle Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'horn_warranty_id',
      label: 'Horn Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'lights_warranty_id',
      label: 'Lights Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'ignition_key_id',
      label: 'Ignition Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'shock_absorber_id',
      label: 'Shock Absorber Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'wiring_kit_id',
      label: 'Wiring Kit Warranty',
      type: 'dropdown',
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: 'col-lg-4',
    },
    {
      name: 'productimage',
      label: 'Product Image',
      type: 'file',
      required: true,
      multiple: true,
      gridClass: 'col-lg-4',
      validation: { required: true },
      allowedExtensions: ['jpg', 'jpeg', 'png', 'pdf'],
    },
    {
      name: 'status',
      label: 'Status',
      type: 'toggle',
      gridClass: 'col-lg-1',
    },
  ];

  const fetchProductOptions = async () => {
    try {
      const payload = {
        orderBy: 'product_id desc',
        page: 0,
        pageSize: 100,
      };

      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        '/product/ddlproduct',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  const fetchSubproductOptions = async (productId) => {
    console.log('productId', productId);
    try {
      const payload = {
        orderBy: 'subproduct_id desc',
        page: 0,
        pageSize: 100,
        product_id: productId,
      };

      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        '/subproduct/ddlsubproduct',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((subproduct) => ({
        label: subproduct.NAME,
        value: subproduct.ID,
      }));

      setSubproductOptions(options);
      console.log(options, 'SubproductOptions');
    } catch (error) {
      console.error('Error fetching subproduct options:', error);
    }
  };

  const fetchBatteryOptions = async (mId) => {
    try {
      const response = await axiosInstance.get('/battery/battery-ddl', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((battery) => ({
        label: battery.NAME,
        value: battery.ID,
      }));

      setBatteryOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;
    const colorId = formData.vehiclecolor;
    const batteryId = formData.variantName;

    // Guard: If Model has actually changed, clear dependent fields and fetch new colors
    if (prevModelRef.current !== modelId) {
      setColorOptions([]);
      setFormData((prev) => ({
        ...prev,
        vehiclecolor: null,
        variantName: null,
        description: '',
      }));
      prevModelRef.current = modelId;

      if (modelId) {
        fetchColorOptions(modelId);
      }
      return; // Stop here and wait for the re-render with cleared values
    }

    // Only fetch variant name if all components are present and stable
    if (modelId && colorId && batteryId) {
      fetchVariantName(modelId, colorId, batteryId);
    }
  }, [formData.model, formData.vehiclecolor, formData.variantName]);

  const fetchVariantName = async (modelId, colorId, variantName) => {
    try {
      const payload = {
        model_id: modelId,
        color_id: colorId,
        variant_name: variantName,
      };

      const response = await axiosInstance.post(
        '/variant/generatename',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const fullVariantName = response?.data?.data;
      console.log(fullVariantName, 'fullVariantName');
      // description

      setFormData((prev) => ({
        ...prev,
        description: fullVariantName,
      }));
    } catch (error) {
      console.error('Error fetching subproduct options:', error);
    }
  };

  const fetchMakeOptions = async (subproductId) => {
    try {
      const payload = {
        orderBy: 'make_id desc',
        page: 0,
        pageSize: 100,
        subproduct_id: subproductId,
      };

      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/make/ddlmake', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((make) => ({
        label: make.NAME,
        value: make.ID,
      }));

      setMakeOptions(options);
    } catch (error) {
      console.error('Error fetching make options:', error);
    }
  };

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  const fetchFuelOptions = async () => {
    try {
      const payload = {};

      const response = await axiosInstance.post(
        '/fueltype/ddlfueltype',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((fuel) => ({
        label: fuel.NAME,
        value: fuel.ID,
      }));
      setFuelOptions(options);
    } catch (error) {
      console.error('Error fetching fuel options:', error);
    }
  };


  const fetchColorOptions = async (modelId) => {
    try {
      const payload = {
        model_id: modelId,
      };
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/color/ddlcolor', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error('Error fetching color options:', error);
    }
  };

  const fetchSeatingCapacityOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        '/seatcapacity/ddlseatcapacity',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      console.log('response', response);
      const options = response.data.data.data?.map((seating) => ({
        label: seating.NAME,
        value: seating.ID,
      }));

      setSeatingCapacityOptions(options);
      console.log('options', options);
    } catch (error) {
      console.error('Error fetching seating capacity options:', error);
    }
  };

  const fetchNoOfWheelsOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/wheel/ddlwheel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((wheels) => ({
        label: wheels.NAME,
        value: wheels.ID,
      }));

      setNoOfWheelsOptions(options);
    } catch (error) {
      console.error('Error fetching no of wheels options:', error);
    }
  };

  const fetchWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        '/warranty/ddlwarranty',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error('Error fetching warranty options:', error);
    }
  };

  useEffect(() => {
    fetchMotorWarrantyOptions();
    fetchControllerWarrantyOptions();
    fetchConverterWarrantyOptions();
  }, []);

  const fetchMotorWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 8;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 8;
      }

      const response = await axiosInstance.post('/item/itemDDL', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setMotorWarranty(options);
    } catch (error) {
      console.error('Error fetching warranty options:', error);
    }
  };

  const fetchControllerWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 10;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 10;
      }

      const response = await axiosInstance.post('/item/itemDDL', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setControllerWarranty(options);
    } catch (error) {
      console.error('Error fetching warranty options:', error);
    }
  };

  const fetchConverterWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 9;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 9;
      }

      const response = await axiosInstance.post('/item/itemDDL', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setConverterWarranty(options);
    } catch (error) {
      console.error('Error fetching warranty options:', error);
    }
  };

  const fetchHsnOptions = async () => {
    try {
      const payload = {};
      if (userType === 'superadmin') {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        '/hsncode/ddlhsncode',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setHsnCodeOptions(options);
    } catch (error) {
      console.error('Error fetching warranty options:', error);
    }
  };

  useEffect(() => {
    fetchProductOptions();
    fetchFuelOptions();
    // fetchColorOptions();
    fetchSeatingCapacityOptions();
    fetchNoOfWheelsOptions();
    fetchWarrantyOptions();
    fetchHsnOptions();
  }, [formData?.business_partner_id, userType !== 'superadmin']);

  // useEffect(() => {
  //   if (formData.productName && formData.productName) {
  //     fetchSubproductOptions(formData.productName);
  //     setSubproductOptions([]);
  //     setMakeOptions([]);
  //     setModelOptions([]);
  //   }
  // }, [formData.productName]);

  useEffect(() => {
    fetchSubproductOptions();
    setMakeOptions();
    fetchBatteryOptions();
  }, []);

  useEffect(() => {
    fetchModelOptions();
  }, []);

  // useEffect(() => {
  //   if (formData.subproductName && formData.subproductName) {
  //     fetchMakeOptions(formData.subproductName);
  //     setMakeOptions([]);
  //     setModelOptions([]);
  //   }
  // }, [formData.subproductName]);

  useEffect(() => {
    setFormData({ ...formData, subsidyprice: '' });
    setApplysubsidy(false);

    if (
      formData.subproductName &&
      formData.fuel &&
      formData.exshowroomprice &&
      formData.cubic_capacity
    ) {
      let SubproductNAME = subproductOptions.find(
        (item) => item.value == formData.subproductName,
      );
      let FuleNAME = fuelOptions.find((item) => item.value == formData.fuel);

      console.log(
        SubproductNAME?.label.toLowerCase(),
        FuleNAME.label.toLowerCase(),
        'subproductvariant',
      );

      if (
        SubproductNAME?.label?.replace(/\s+/g, '').toLowerCase() ===
          'electric' &&
        FuleNAME?.label?.replace(/\s+/g, '').toLowerCase() ===
          'electrichighspeed'
      ) {
        setApplysubsidy(true);
        let discountamt = formData.exshowroomprice * 0.4;
        let kwdiscount = formData.cubic_capacity * 15000;
        console.log(
          2,
          discountamt,
          kwdiscount,
          'formDatavariantexshowroomprice',
        );
        if (kwdiscount > discountamt) {
          setFormData({ ...formData, subsidyprice: discountamt });
        } else {
          setFormData({ ...formData, subsidyprice: kwdiscount });
        }
      } else {
        setApplysubsidy(false);
      }
    }
  }, [
    formData.exshowroomprice,
    formData.fuel,
    formData.subproductName,
    formData.cubic_capacity,
  ]);

  useEffect(() => {
    if (formData.make && formData.make) {
      fetchModelOptions(formData.make);
      setModelOptions([]);
    }
  }, [formData.make]);

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    VariantInputs.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = 'This field is required';
        isValid = false;
      }
      if (
        field.validation?.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field?.name] = field?.validation?.message;
        isValid = false;
      }
    });
    if (
      formData.dealer_price &&
      formData.exshowroomprice &&
      Number(formData.dealer_price) > Number(formData.exshowroomprice)
    ) {
      errors.dealer_price =
        'Dealer Price cannot be greater than Ex-Showroom Price';
      isValid = false;
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    showCustomAlert({
      title: 'Confirm',
      text: 'Are you sure you want to add this record in Variant?',
      icon: 'question',
      confirmButtonText: 'Yes',
      callback: async () => {
        try {
          setLoading(true);
          const newformData = new FormData();
          // state_id
          newformData.append('product_id', formData.productName);
          newformData.append('subproduct_id', 1); //change it to static value
          newformData.append('make_id', 1); //change it to static value
          newformData.append('model_id', formData.model);
          newformData.append('fuel_type_id', 1); //change it to static value
          newformData.append('cubic_capacity', 0);
          newformData.append('variant_name', formData.variantName || 0);
          newformData.append('color_id', formData.vehiclecolor);
          newformData.append('state_id', formData.state_id);
          newformData.append('dealer_price', formData.dealer_price);
          // is_on_created: formData.is_on_created===true ? 1:0,
          newformData.append('is_finance_available', 0);
          newformData.append('exshowroom_price', formData.exshowroomprice);

          newformData.append('variant_desc', formData.description);
          // newformData.append("battery_warranty_id", formData.battery_warranty_id || 0);
          newformData.append(
            'motor_warranty_id',
            formData.motor_warranty_id || 0,
          );
          newformData.append(
            'converter_warranty_id',
            formData.converter_warranty_id || 0,
          );
          newformData.append(
            'controller_warranty_id',
            formData.controller_warranty_id || 0,
          );
          newformData.append(
            'charger_warranty_id',
            formData.charger_warranty_id || 0,
          );

          newformData.append('mcb_warranty_id', formData.mcb_warranty_id || 0);
          newformData.append(
            'throttle_warranty_id',
            formData.throttle_warranty_id || 0,
          );
          newformData.append(
            'horn_warranty_id',
            formData.horn_warranty_id || 0,
          );
          newformData.append(
            'lights_warranty_id',
            formData.lights_warranty_id || 0,
          );
          newformData.append('ignition_key_id', formData.ignition_key_id || 0);
          newformData.append(
            'shock_absorber_id',
            formData.shock_absorber_id || 0,
          );
          newformData.append('wiring_kit_id', formData.wiring_kit_id || 0);

          formData?.subsidyprice &&
            newformData.append('subsidyprice', formData.subsidyprice);
          newformData.append('tax_id', formData.taxid);
          // newformData.append("is_finance_available", formData.is_finance_available === true ? 1:0);
          newformData.append('status', formData.status === true ? 1 : 0);

          // Append each file individually
          if (formData.productimage && Array.isArray(formData.productimage)) {
            formData.productimage.forEach((file, index) => {
              newformData.append(`variant_image`, file);
            });
          }

          const response = await axiosInstance.post(
            '/variant/create',
            newformData,
            {
              headers: {
                Authorization: `Bearer ${authToken}`, // Do not set Content-Type for FormData
              },
            },
          );

          console.log('API Response:', response.data);

          if (response.status === 200) {
            await showAlert({
              title: 'Success',
              text: 'Variant added successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
            navigate('/admin/manage-product/variant');
          }
        } catch (error) {
          console.error('Error submitting form:', error);

          const errorMessage = error.response?.data?.message;

          showErrorAlert({
            title: errorMessage,
            text:
              errorMessage ||
              'An error occurred while processing your request.',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  //   const handleFormSubmit = async (formData) => {
  //     console.log("variantformdata",formData);

  //     const errors = {};
  //     let isValid = true;

  //     VariantInputs.forEach((field) => {
  //       if (field.required && !formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //       if (field.validation?.pattern && !field.validation.pattern.test(formData[field.name])) {
  //         errors[field?.name] = field?.validation?.message;
  //         isValid = false;
  //       }else if (field?.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     });

  //     if (!isValid) {
  //       setValidationErrors(errors);
  //       return;
  //     }

  //     showCustomAlert({
  //       title: "Success",
  //       text:"Are you sure you want to add this record in Variant.",
  //       confirmButtonText: "Variant added successfully.",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //       callback: async () => {

  //     try {
  //       setLoading(true)
  //       const newformData = new FormData();
  //       newformData.append("product_id", formData.productName);
  //       newformData.append("subproduct_id", formData.subproductName);
  //       newformData.append("make_id", formData.make);
  //       newformData.append("model_id", formData.model);
  //       newformData.append("fuel_type_id", formData.fuel);
  //       newformData.append("cubic_capacity", formData.cubic_capacity);
  //       newformData.append("variant_name", formData.variantName);
  //       newformData.append("color_id", formData.vehiclecolor);
  //       newformData.append("exshowroom_price", formData.exshowroomprice);
  //       newformData.append("variant_desc",formData.description);
  //       newformData.append("warranty_id", formData.warranty_id);
  //       newformData.append("subsidyprice",applysubsidy?String(formData.subsidyprice):null);
  //       newformData.append("tax_id", formData.taxid);
  //       newformData.append("status", formData.status === true ? 1 : 0);
  //       newformData.append("variant_image",formData?.productimage)

  //       const response = await axiosInstance.post('/variant/create', newformData, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       });

  //       console.log("API Response:", response.data);

  //       if (response.status === 200) {
  //         navigate('/admin/manage-product/variant');  // Navigate after user clicks OK
  //       }

  //     } catch (error) {
  //       console.error('Error submitting form:', error);

  //       const errorMessage = error.response?.data?.message

  //       showErrorAlert({
  //         title: "Something went wrong",
  //         text: errorMessage || "An error occurred while processing your request.",
  //         callback: () => {
  //           // Optional: code to execute after confirming the alert
  //           console.log("Error alert confirmed");
  //         }
  //       });
  //     }
  //     finally{
  //       setLoading(false)
  //     }
  //   },
  // });
  //   };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate("/admin/manage-product/variant")}
            >
              <img
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Variant</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Variant Details
              </span>
              <DynamicForm
                formConfig={VariantInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(VariantInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  VariantInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? 'Processing...' : 'Submit'}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddVariant;
